import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import PubSub, { topics } from '../../lib/pubsub';

import Top from '../navigation/top';
import BrandList from './list';

const initialState = {
    height: 100,
};

@observer
class Brand extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    render(props = this.props) {
        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <BrandList {...props} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Brand;



// WEBPACK FOOTER //
// ./components/productcombos/index.js